// extracted by mini-css-extract-plugin
module.exports = {"resultsExplanationItem":"styles_resultsExplanationItem__1mI1q","title":"styles_title__1qHCQ","description":"styles_description__3Jtuw"};